import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import {
  createIssueDetailsSlice,
  IssueDetailsSlice,
} from './storeSlices/issueDetails';
import {
  createYourDetailsSlice,
  YourDetailsSlice,
} from './storeSlices/yourDetails';
import {
  CombinedSlice,
  createCombinedSlice,
} from './storeSlices/combinedDetails';

export const useAbVehiclesStore = create<
  YourDetailsSlice & IssueDetailsSlice & CombinedSlice
>()(
  persist(
    (...a) => ({
      ...createIssueDetailsSlice(...a),
      ...createYourDetailsSlice(...a),
      ...createCombinedSlice(...a),
    }),
    {
      name: 'report-it-vehicles-abandoned-storage',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
